// Libraries
import { Link, Text } from '@chakra-ui/react';
// Utils
import text from '@translations/en.json';
// Types
import { MailtoTextProps } from './MailtoText.types';

/**
 * MailtoText component displays a mailto link with the contact email address.
 *
 * @component
 * @param {MailtoTextProps} props - The component props.
 * @param {string} props.error - The error message to display.
 * @param {string} props.email -  The email address.
 * @returns {ReactElement} The JSX element representing the MailtoText component.
 */
export const MailtoText = ({ error, email, ...rest }: MailtoTextProps) => {
  const subject = encodeURIComponent(text.mailto_subject);
  const body = encodeURIComponent(`${text.mailto_body_intro}${error}${text.mailto_body_ending}`);
  const mailtoMessage = `mailto:${email}?Subject=${subject}&body=${body}`;

  return (
    <Text variant='modalTitle' {...rest}>
      {text.mailto_contact}
      <Link color='primaryPurple.100' href={mailtoMessage} fontSize={rest.fontSize}>
        {email}
      </Link>
      {text.mailto_assistance}
    </Text>
  );
};
